import { makeStyles, tokens } from "@fluentui/react-components";
export const useToastContentStyles = makeStyles({
    dismissButton: {
        paddingTop: "0px",
        paddingBottom: "0px",
        // Inherit the button's themed hover/focus color so the X adapts in HC; !important beats the icon's own className.
        ":hover, :focus-visible": {
            "& svg": {
                color: "inherit !important"
            }
        }
    },
    dismissIconInverted: {
        color: tokens.colorNeutralForegroundInverted2
    },
    dismissIconDefault: {
        color: tokens.colorNeutralForeground1
    }
});
